import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import useIsDesktop from 'src/hooks/useIsDesktop';
import { makeSelectBusinessPart } from 'src/hocs/App/selectors';
import { images } from 'src/theme/assets/images';
import { Url } from 'src/utils/routes/routes';
import { useContactChannel } from 'src/hocs/WithCustomerService/hooks';
import Text from 'src/components/ui/typography/text/Text';
import HeaderContact from 'src/components/organisms/Header/HeaderContact';
import { useLocationTitle } from 'src/components/organisms/Header/useLocationTitle';
import { useIntlMessage } from 'src/components/utils/LanguageProvider/intl.helpers';
import { isGroupPurchase } from 'src/components/pages/GroupPurchase/GroupPurchase.logic.helper';
import strings from 'src/translations/strings.json';
import { TranslationKeys } from 'src/components/utils/LanguageProvider/intl.types';
import { displayHeaderSentence } from 'src/hocs/WithCustomerService/logic.helper';
import * as S from './Header.styles';

const {
  REACT_APP_HOME_URL = '',
  REACT_APP_PARTNER_LOGO_URL = '',
  REACT_APP_STATIC_URL = '',
  REACT_APP_TENANT = '',
} = process.env;

export const Header = (): JSX.Element => {
  const [logoLoadStatus, setLogoLoadStatus] = useState(true);
  const { intlMessage } = useIntlMessage();
  const isDesktop = useIsDesktop();
  const businessPart = useSelector(makeSelectBusinessPart());
  useContactChannel();
  const hasPartnerLogo = businessPart?.toLocaleLowerCase() !== REACT_APP_TENANT && logoLoadStatus;
  const handleLogoLoadError = useCallback(() => {
    setLogoLoadStatus(false);
  }, []);
  const title = useLocationTitle();

  const canDisplaySentence = displayHeaderSentence(businessPart);
  const sentenceKey = `app.header.sentence.${businessPart}`;

  return (
    <S.AppHeader>
      <S.Container>
        <S.AppLogoContainer href={REACT_APP_HOME_URL}>
          <S.AppLogo src={images.appHeaderLogo} alt="" />
        </S.AppLogoContainer>
        {!isGroupPurchase() && hasPartnerLogo && (
          <S.PartnerLogo
            src={Url(`${REACT_APP_STATIC_URL}${REACT_APP_TENANT}${REACT_APP_PARTNER_LOGO_URL}`, {
              business_part: businessPart,
            })}
            alt={`logo ${businessPart}`}
            onError={handleLogoLoadError}
          />
        )}
        {title && (
          <S.StepTitle type="l" color="attenuated" hasPartnerLogo={hasPartnerLogo}>
            {title}
          </S.StepTitle>
        )}
        {canDisplaySentence && (
          <S.SelectraGroupPurchaseText>
            <Text align="right">
              {sentenceKey in strings
                ? intlMessage(sentenceKey as TranslationKeys, { hasFullText: isDesktop })
                : ''}
            </Text>
          </S.SelectraGroupPurchaseText>
        )}
        <HeaderContact businessPart={businessPart} isDesktop={isDesktop} />
      </S.Container>
    </S.AppHeader>
  );
};
